import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, unref as _unref, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-079d425c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { value: "" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "14",
  height: "14",
  viewBox: "0 0 14 14",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M11.3749 4.45053L6.99992 8.71615L2.62492 4.45053C2.54296 4.36857 2.44729 4.32759 2.33792 4.32759C2.22854 4.32759 2.13287 4.36857 2.05092 4.45053C1.96896 4.53248 1.92798 4.62815 1.92798 4.73753C1.92798 4.8469 1.96444 4.93805 2.03735 5.01096L6.69935 9.55002C6.78131 9.63198 6.88165 9.67296 7.00035 9.67296C7.11906 9.67296 7.2194 9.63198 7.30135 9.55002L11.9634 5.02453C12.0363 4.94257 12.0727 4.84457 12.0727 4.73052C12.0727 4.61648 12.0317 4.52082 11.9498 4.44353C11.8678 4.36623 11.7722 4.32744 11.6628 4.32715C11.5534 4.32686 11.4578 4.36784 11.3758 4.45009L11.3749 4.45053Z",
    fill: "#909399"
  })
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "frisbuy-select__popper--arrow" }, null, -1))
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "frisbuy-select__option-text" }

import { HTMLAttributes, onMounted, ref, watch } from "vue";
import vClickOutside from "@/common/directives/vClickOutside";

type TSelectOption = {
  value: string | number | symbol | undefined;
  text: string;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'FrSelect',
  props: {
    modelValue: { default: () => {
      return { value: undefined, text: "" };
    } },
    options: {},
    defaultOption: {},
    customStyle: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

onMounted(() => {
  if (props.defaultOption) {
    setDefaultOption(props.defaultOption);
  }
});

const selectOptions = ref();
const isSelectMenuOpen = ref(false);

function openSelectMenu() {
  isSelectMenuOpen.value = true;

  selectOptions?.value.focus();
}

function closeSelectMenu() {
  isSelectMenuOpen.value = false;
}

function selectMenuClickHandler() {
  if (isSelectMenuOpen.value) {
    closeSelectMenu();
  } else {
    /* NOTE:
      vClickOutside without this timeout is called immediately
      after openSelectMenu via select-button's @click
    */
    setTimeout(() => {
      openSelectMenu();
    });
  }
}

function setDefaultOption(option: TSelectOption) {
  selectedOption.value = option;
}

const selectedOption = ref<TSelectOption>(props.modelValue);
function selectOption(option: TSelectOption) {
  emit("update:modelValue", option);

  selectedOption.value = option;
  closeSelectMenu();
}

watch(
  () => props.modelValue,
  (value) => {
    selectedOption.value = value;
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "frisbuy-select",
    style: _normalizeStyle(_ctx.customStyle)
  }, [
    _createElementVNode("button", {
      class: _normalizeClass(["frisbuy-select__select-button", { 'frisbuy-select__select-button--is-open': isSelectMenuOpen.value }]),
      onClick: selectMenuClickHandler
    }, [
      _createElementVNode("span", _hoisted_1, _toDisplayString(selectedOption.value.text), 1),
      _hoisted_2
    ], 2),
    _withDirectives((_openBlock(), _createElementBlock("div", {
      class: _normalizeClass(["frisbuy-select__options", { '--is-closed': !isSelectMenuOpen.value }]),
      ref_key: "selectOptions",
      ref: selectOptions,
      tabindex: "-1"
    }, [
      _hoisted_3,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.options, (option) => {
        return (_openBlock(), _createElementBlock("div", {
          key: option.value,
          class: "frisbuy-select__option",
          onClick: () => selectOption(option)
        }, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(option.text), 1)
        ], 8, _hoisted_4))
      }), 128))
    ], 2)), [
      [_unref(vClickOutside), closeSelectMenu]
    ])
  ], 4))
}
}

})